export const NAME = 'Ivan Moskvin'
